import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from '@core/services/feature-flag.service';

@Directive({
    selector: '[appFeatureDiscovery]',
    standalone: false,
})
export class FeatureDiscoveryDirective implements OnInit {
    @Input() featureFlagKey: string;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @Input() customTarget: any;

    constructor(
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private featureFlagService: FeatureFlagService
    ) {}

    async ngOnInit() {
        const show = await this.featureFlagService.isFeatureEnabled(
            this.featureFlagKey,
            false,
            this.customTarget
        );

        if (show) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
